var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { column: "" } },
    [
      _c("span", { staticClass: "mb-1" }, [
        _vm._v(
          "\n    Ative para programar o envio ou mantenha desativado para enviar\n    imediatamente.\n  "
        )
      ]),
      _vm._v(" "),
      _c("v-switch", {
        staticClass: "pl-3",
        attrs: { color: "primary", value: _vm.schedule, inset: "" },
        on: { change: _vm.setSchedule },
        scopedSlots: _vm._u([
          {
            key: "label",
            fn: function() {
              return [
                _vm._v("\n      Programar envio\n      "),
                _c(
                  "v-chip",
                  {
                    staticClass: "ml-1",
                    attrs: { color: _vm.chipColor, small: "" }
                  },
                  [_vm._v(_vm._s(_vm.chipLabel))]
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "v-slide-y-transition",
        [
          _c(
            "v-form",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.schedule,
                  expression: "schedule"
                }
              ]
            },
            [
              _c("v-select", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                attrs: {
                  dense: "",
                  filled: "",
                  required: "",
                  disabled: "",
                  name: "timeZone",
                  label: "timezone",
                  "prepend-inner-icon": "mdi-alarm-snooze",
                  items: _vm.timeZoneOptions,
                  error: _vm.errors.has("timeZone"),
                  "error-messages": _vm.errors.first("timeZone")
                },
                on: { input: _vm.setTimeZone },
                model: {
                  value: _vm.timeZone,
                  callback: function($$v) {
                    _vm.timeZone = $$v
                  },
                  expression: "timeZone"
                }
              }),
              _vm._v(" "),
              _c("multiple-date-picker"),
              _vm._v(" "),
              _c("time-picker")
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cddc0682", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cddc0682","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notifications/Send/Steps/Scheduling/Index.vue
// module id = null
// module chunks = 